<app-side-menu>
  <div class="staff-form-container">
    <div class="form-header">
      <h1><i class="fas fa-user-plus"></i> Novo Funcionário</h1>
      <p>Preencha todas as informações necessárias para cadastrar um novo funcionário</p>
    </div>

    <!-- Mensagem de Sucesso -->
    <div *ngIf="successMessage" class="success-message">
      <i class="fas fa-check-circle"></i>
      <span>{{ successMessage }}</span>
    </div>

    <!-- Pop-up de erro personalizado no canto superior direito -->
    <div *ngIf="error" class="staff-error-toast-custom">
      <span class="icon-bg">
        <i class="fas fa-exclamation-triangle"></i>
      </span>
      <span class="msg">{{ error }}</span>
      <button type="button" class="close-btn" (click)="error = null" aria-label="Fechar">&times;</button>
    </div>

    <!-- CSS personalizado para o toast -->
    <style>
.staff-error-toast-custom {
  position: fixed;
  top: 32px;
  right: 32px;
  z-index: 1050;
  background: #f44336; /* vermelho sólido */
  color: #fff;
  padding: 18px 40px 18px 18px;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.18);
  display: flex;
  align-items: center;
  min-width: 320px;
  font-size: 17px;
  gap: 16px;
  border-left: 8px solid #fff176;
  animation: slideInRight 0.4s cubic-bezier(.4,0,.2,1);
}
.staff-error-toast-custom .icon-bg {
  background: #fff176;
  color: #f44336;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin-right: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.10);
}
.staff-error-toast-custom .msg {
  flex: 1;
  font-weight: 500;
}
.staff-error-toast-custom .close-btn {
  background: transparent;
  border: none;
  color: #fff;
  font-size: 26px;
  margin-left: 18px;
  cursor: pointer;
  line-height: 1;
  transition: color 0.2s;
}
.staff-error-toast-custom .close-btn:hover {
  color: #fff176;
}
@keyframes slideInRight {
  from { right: -400px; opacity: 0; }
  to { right: 32px; opacity: 1; }
}
</style>

      <!-- Abas / Steps -->
      <app-form-shell
        [tabs]="availableTabs"
        [activeTab]="activeTab"
        (tabChange)="selectTab($event)">
      </app-form-shell>

      <!-- Conteúdo das Abas -->
      <div class="tab-content">
        
        <!-- Aba: Informações Básicas -->
        <div *ngIf="activeTab === 'basic'" class="tab-panel">
          <div class="detail-section">
            <h3><i class="fas fa-user"></i> Dados Pessoais</h3>
            <div class="detail-grid">
              <!-- Nome Completo - Largura total -->
              <div class="detail-item full-width">
                <label>Nome Completo:</label>
                <input type="text" [(ngModel)]="formData.staff.fullName" placeholder="Digite o nome completo" required>
        </div>

              <!-- Primeira linha: Estrangeiro e CPF/Passaporte -->
              <div class="detail-item">
                <label>É Estrangeiro?</label>
                <input type="checkbox" [(ngModel)]="formData.staff.isForeigner" (change)="onForeignerChange()">
      </div>

                          <div class="detail-item" *ngIf="!formData.staff.isForeigner">
              <label>CPF:</label>
              <input type="text" 
                     [(ngModel)]="formData.staff.cpf" 
                     (input)="applyCPFMask($event)"
                     (blur)="validateCPF(formData.staff.cpf)"
                     placeholder="000.000.000-00" 
                     maxlength="14"
            required>
        </div>
              
              <div class="detail-item" *ngIf="formData.staff.isForeigner">
                <label>Número do Passaporte:</label>
                <input type="text" [(ngModel)]="formData.staff.passportNumber" placeholder="Digite o número do passaporte" required>
        </div>

              <!-- Segunda linha: RG e Órgão Expedidor -->
                          <div class="detail-item">
              <label>RG:</label>
              <input type="text" 
                     [(ngModel)]="formData.staff.rg" 
                     (input)="applyRGMask($event)"
                     (blur)="validateRG(formData.staff.rg || '')"
                     placeholder="Ex: 12.345.678-9 ou 12.345.678-9 SP" 
                     maxlength="20">
      </div>

              <div class="detail-item">
                <label>Órgão Expedidor RG:</label>
                <input type="text" [(ngModel)]="formData.staff.rgIssuingAuthority" placeholder="Ex: SSP, DETRAN">
        </div>

              <!-- Terceira linha: Data de Emissão RG e Data de Nascimento -->
              <div class="detail-item">
                <label>Data de Emissão RG:</label>
                <input type="date" [(ngModel)]="formData.staff.rgIssueDate">
      </div>

              <div class="detail-item">
                <label>Data de Nascimento:</label>
                <input type="date" [(ngModel)]="formData.staff.birthDate" required>
        </div>

              <!-- Quarta linha: Gênero e Estado Civil -->
                          <div class="detail-item">
              <label>Gênero:</label>
              <select [(ngModel)]="formData.staff.gender" required>
                <option value="M">Masculino</option>
                <option value="F">Feminino</option>
                <option value="N">Não informado</option>
          </select>
      </div>

              <div class="detail-item">
                <label>Estado Civil:</label>
                <select [(ngModel)]="formData.staff.maritalStatus" required>
                  <option value="Solteiro">Solteiro</option>
                  <option value="Casado">Casado</option>
                  <option value="Divorciado">Divorciado</option>
                  <option value="Viúvo">Viúvo</option>
          </select>
        </div>

              <!-- Quinta linha: Nome da Mãe e Nome do Pai -->
              <div class="detail-item">
                <label>Nome da Mãe:</label>
                <input type="text" [(ngModel)]="formData.staff.motherName" placeholder="Digite o nome da mãe" required>
      </div>

              <div class="detail-item">
                <label>Nome do Pai:</label>
                <input type="text" [(ngModel)]="formData.staff.fatherName" placeholder="Digite o nome do pai">
        </div>

              <!-- Sexta linha: Nacionalidade e Naturalidade -->
              <div class="detail-item">
                <label>Nacionalidade:</label>
                <input type="text" [(ngModel)]="formData.staff.nationality" placeholder="Ex: Brasileira" required>
        </div>
              
              <div class="detail-item">
                <label>Naturalidade:</label>
                <input type="text" [(ngModel)]="formData.staff.birthPlace" placeholder="Cidade de nascimento" required>
      </div>

              <!-- Sétima linha: Possui Deficiência -->
              <div class="detail-item">
                <label>Possui Deficiência?</label>
                <input type="checkbox" [(ngModel)]="formData.staff.hasDisability">
              </div>
        </div>
      </div>
          <!-- Botões de Navegação -->
          <div class="navigation-buttons">
            <button class="btn btn-secondary" (click)="goToPreviousTab()" [disabled]="isFirstTab()">
              <i class="fas fa-arrow-left"></i>
              Voltar
            </button>

            <button class="btn btn-primary" (click)="goToNextTab()" *ngIf="!isLastTab()" [disabled]="!isTabValid(activeTab)">
              Próximo
              <i class="fas fa-arrow-right"></i>
            </button>

            <button class="btn btn-success" (click)="saveStaff()" *ngIf="isLastTab()" [disabled]="saving || !isTabValid(activeTab)">
              <i class="fas fa-save"></i>
              {{ saving ? 'Cadastrando...' : 'Cadastrar Funcionário' }}
            </button>
      </div>
    </div>

    <!-- Stage 2: Endereço -->
    <div *ngIf="activeTab === 'addresses'" class="tab-panel">
      <div class="detail-section">
        <h3><i class="fas fa-map-marker-alt"></i> Endereços</h3>
        
        <div *ngFor="let address of formData.addresses; let i = index" class="address-item">
          <div class="address-header">
            <span class="address-type">{{ address.addressType || 'Residencial' }}</span>
            <span *ngIf="address.isDefault" class="default-badge">Padrão</span>
            <button *ngIf="formData.addresses.length > 1" 
                    class="btn btn-danger btn-sm" 
                    (click)="removeAddress(i)" 
                    type="button">
              <i class="fas fa-trash"></i>
              Remover
            </button>
      </div>

          <div class="detail-grid">
            <div class="detail-item">
              <label>Rua:</label>
              <input type="text" [(ngModel)]="address.street" class="edit-input" placeholder="Digite o nome da rua">
            </div>
            <div class="detail-item">
              <label>Número:</label>
              <input type="text" [(ngModel)]="address.number" class="edit-input" placeholder="Digite o número">
            </div>
            <div class="detail-item">
              <label>Complemento:</label>
              <input type="text" [(ngModel)]="address.complement" class="edit-input" placeholder="Complemento (opcional)">
            </div>
            <div class="detail-item">
              <label>Bairro:</label>
              <input type="text" [(ngModel)]="address.neighborhood" class="edit-input" placeholder="Digite o bairro">
            </div>
            <div class="detail-item">
              <label>Cidade:</label>
              <input type="text" [(ngModel)]="address.city" class="edit-input" placeholder="Digite a cidade">
        </div>
            <div class="detail-item">
              <label>Estado:</label>
              <input type="text" [(ngModel)]="address.state" class="edit-input" placeholder="Digite o estado">
        </div>
                <div class="form-group">
                  <label for="zipCode{{i}}">CEP:</label>
                  <div class="cep-input-group">
                    <input type="text" 
                           id="zipCode{{i}}" 
                           name="zipCode{{i}}" 
                           [(ngModel)]="address.zipCode" 
                           class="form-control cep-input" 
                           placeholder="00000-000"
                           maxlength="9">
                    <button type="button" 
                            class="btn btn-outline-primary btn-sm cep-button"
                            (click)="consultarCEP(address.zipCode, i)"
                            title="Consultar CEP automaticamente">
                      <i class="fas fa-search"></i>
                      CEP
                    </button>
                  </div>
                </div>
            <div class="detail-item">
              <label>País:</label>
              <input type="text" [(ngModel)]="address.country" class="edit-input" placeholder="Digite o país">
        </div>
            <div class="detail-item">
              <label>Endereço Padrão:</label>
              <input type="checkbox" [(ngModel)]="address.isDefault">
        </div>
      </div>
        </div>

        <div class="address-actions">
          <button class="btn btn-secondary" (click)="addAddress()" type="button">
            <i class="fas fa-plus"></i>
            Adicionar Outro Endereço
          </button>
        </div>
      </div>
      <!-- Botões de Navegação -->
      <div class="navigation-buttons">
        <button class="btn btn-secondary" (click)="goToPreviousTab()" [disabled]="isFirstTab()">
          <i class="fas fa-arrow-left"></i>
          Voltar
        </button>

        <button class="btn btn-primary" (click)="goToNextTab()" *ngIf="!isLastTab()" [disabled]="!isTabValid(activeTab)">
          Próximo
          <i class="fas fa-arrow-right"></i>
        </button>

        <button class="btn btn-success" (click)="saveStaff()" *ngIf="isLastTab()" [disabled]="saving || !isTabValid(activeTab)">
          <i class="fas fa-save"></i>
          {{ saving ? 'Cadastrando...' : 'Cadastrar Funcionário' }}
        </button>
      </div>
    </div>
      <!-- Aba: Dados Bancários -->
      <div *ngIf="activeTab === 'banking'" class="tab-panel">
        <div class="detail-section">
          <h3><i class="fas fa-university"></i> Dados Bancários</h3>
          
          <div class="banking-item">
            <div class="banking-header">
              <h4>Conta Bancária</h4>
              <!-- Dados bancários são únicos por funcionário -->
        </div>
            
            <div class="detail-grid">
              <div class="detail-item">
                <label>Banco:</label>
                <select [(ngModel)]="formData.staff.bankName" 
                        (change)="updateTabsCompletionStatus()"
                        required>
                  <option value="">Selecione o banco</option>
                  <option *ngFor="let bank of BANKS_OPTIONS" 
                          [value]="bank.value">
                    {{ bank.label }}
                  </option>
                </select>
        </div>
              
              <div class="detail-item">
                <label>Agência:</label>
                <input type="text" 
                       [(ngModel)]="formData.staff.agency" 
                       (input)="updateTabsCompletionStatus()"
                       placeholder="Ex: 1234" 
                       maxlength="10"
                       required>
      </div>

              <div class="detail-item">
                <label>Tipo de Conta:</label>
                <select [(ngModel)]="formData.staff.accountType" 
                        (change)="updateTabsCompletionStatus()"
                        required>
                  <option value="">Selecione o tipo</option>
                  <option *ngFor="let type of ACCOUNT_TYPE_OPTIONS" 
                          [value]="type.value">
                    {{ type.label }}
                  </option>
                </select>
        </div>
              
              <div class="detail-item">
                <label>Número da Conta:</label>
                <input type="text" 
                       [(ngModel)]="formData.staff.accountNumber" 
                       (input)="updateTabsCompletionStatus()"
                       placeholder="Ex: 12345-6" 
                       maxlength="20"
                       required>
        </div>
              
              <div class="detail-item">
                <label>Nome do Titular:</label>
                <input type="text" 
                       [(ngModel)]="formData.staff.accountHolderName" 
                       (input)="updateTabsCompletionStatus()"
                       placeholder="Nome completo do titular"
                       maxlength="200">
      </div>

              <div class="detail-item">
                <label>Chave PIX:</label>
                <input type="text" 
                       [(ngModel)]="formData.staff.pixKey" 
                       (input)="updateTabsCompletionStatus()"
                       placeholder="CPF, email, telefone ou chave aleatória"
                       maxlength="100">
      </div>

              <!-- Campo notes removido - não existe no objeto staff -->
      </div>
    </div>

                    <!-- Dados bancários são únicos por funcionário -->
      </div>
      
      <!-- Botões de Navegação -->
      <div class="navigation-buttons">
        <button class="btn btn-secondary" (click)="goToPreviousTab()" [disabled]="isFirstTab()">
          <i class="fas fa-arrow-left"></i>
          Voltar
        </button>

        <button class="btn btn-primary" (click)="goToNextTab()" *ngIf="!isLastTab()" [disabled]="!isTabValid(activeTab)">
          Próximo
          <i class="fas fa-arrow-right"></i>
        </button>

        <button class="btn btn-success" (click)="saveStaff()" *ngIf="isLastTab()" [disabled]="saving || !isTabValid(activeTab)">
          <i class="fas fa-save"></i>
          {{ saving ? 'Cadastrando...' : 'Cadastrar Funcionário' }}
        </button>
      </div>
    </div>

    <!-- Stage 3: Contatos -->
    <div *ngIf="activeTab === 'contacts'" class="tab-panel">
      <div class="detail-section">
        <h3><i class="fas fa-phone"></i> Contatos <span class="contact-counter">({{ formData.contacts.length }} contatos)</span></h3>
        
       
        
        <div *ngFor="let contact of formData.contacts; let i = index" class="contact-item">
          <div class="contact-header">
            <span class="contact-type">{{ contact.contactType }}</span>
            <span class="contact-relationship">{{ contact.relationship }}</span>
            <span *ngIf="contact.isEmergencyContact" class="emergency-badge">Emergência</span>
            <span *ngIf="contact.isDefault" class="default-badge">Padrão</span>
            <button *ngIf="i > 1" 
                    class="btn btn-danger btn-sm" 
                    (click)="removeContact(i)" 
                    type="button">
              <i class="fas fa-trash"></i>
              Remover
            </button>
          </div>

          <div class="detail-grid">
            <div class="detail-item">
              <label>Tipo de Contato:</label>
              <select [(ngModel)]="contact.contactType" (change)="onContactTypeChange(contact)" class="edit-select">
                <option value="Telefone">Telefone</option>
                <option value="Email">Email</option>
                <option value="WhatsApp">WhatsApp</option>
                <option value="Celular">Celular</option>
              </select>
            </div>
            <div class="detail-item">
              <label>Nome/Valor:</label>
              <input type="text" [(ngModel)]="contact.contactName" class="edit-input" placeholder="Nome ou valor do contato">
            </div>
            <div class="detail-item">
              <label>{{ getContactLabel(contact.contactType) }}:</label>
              <input *ngIf="contact.contactType === 'Email'" 
                     type="email" 
                     [(ngModel)]="contact.phoneNumber" 
                     class="edit-input" 
                     placeholder="email@exemplo.com">
              <input *ngIf="contact.contactType !== 'Email'" 
                     type="text" 
                     [(ngModel)]="contact.phoneNumber" 
                     (input)="applyPhoneMaskToContact($event, contact)"
                     class="edit-input" 
                     [placeholder]="getContactPlaceholder(contact.contactType)">
            </div>
            <div class="detail-item">
              <label>Relacionamento:</label>
              <select [(ngModel)]="contact.relationship" class="edit-select">
                <option value="Próprio">Próprio</option>
                <option value="Familiar">Familiar</option>
                <option value="Amigo">Amigo</option>
                <option value="Trabalho">Trabalho</option>
              </select>
            </div>
            <div class="detail-item">
              <label>Contato de Emergência:</label>
              <input type="checkbox" [(ngModel)]="contact.isEmergencyContact" [disabled]="i < 2">
              <small class="text-muted" *ngIf="i < 2">(Automático baseado na posição)</small>
              <small class="text-muted" *ngIf="i >= 2">(Escolha se é contato de emergência)</small>
            </div>
            <div class="detail-item">
              <label>Contato Padrão:</label>
              <input type="checkbox" [(ngModel)]="contact.isDefault" [disabled]="i < 2">
              <small class="text-muted" *ngIf="i < 2">(Automático para o 1º contato)</small>
              <small class="text-muted" *ngIf="i >= 2">(Escolha se é contato padrão)</small>
            </div>
          </div>
        </div>

        <div class="add-button-container">
            <button type="button" 
                    class="btn btn-outline-primary" 
                    (click)="addContact()">
              <i class="fas fa-plus"></i>
              Adicionar Outro Contato
            </button>
        </div>
      </div>
      
      <!-- Botões de Navegação -->
      <div class="navigation-buttons">
        <button class="btn btn-secondary" (click)="goToPreviousTab()" [disabled]="isFirstTab()">
          <i class="fas fa-arrow-left"></i>
          Voltar
        </button>

        <button class="btn btn-primary" (click)="goToNextTab()" *ngIf="!isLastTab()" [disabled]="!isTabValid(activeTab)">
          Próximo
          <i class="fas fa-arrow-right"></i>
        </button>

        <button class="btn btn-success" (click)="saveStaff()" *ngIf="isLastTab()" [disabled]="saving || !isTabValid(activeTab)">
          <i class="fas fa-save"></i>
          {{ saving ? 'Cadastrando...' : 'Cadastrar Funcionário' }}
        </button>
      </div>
    </div>

    <!-- Aba: Contrato -->
    <div *ngIf="activeTab === 'contract'" class="tab-panel">
      <div class="detail-section">
        <h3><i class="fas fa-file-contract"></i> Informações do Contrato</h3>
        <div class="detail-grid">
          <div class="detail-item">
            <label>Matrícula:</label>
            <input type="text" [(ngModel)]="formData.staff.registration" class="edit-input" placeholder="Digite a matrícula" required>
          </div>
          <div class="detail-item">
            <label>Departamento <span style="color: red;">*</span>:</label>
            <select [(ngModel)]="formData.staff.department" 
                    (change)="onDepartmentChange(formData.staff.department)"
                    class="edit-select" 
                    required>
              <option value="">Selecione o departamento</option>
              <option *ngFor="let dept of departments" [value]="dept.name">
                {{ dept.name }}
              </option>
            </select>
            <small class="form-text text-muted" *ngIf="isLoadingDepartments">
              Carregando departamentos...
            </small>
          </div>
          <div class="detail-item">
            <label>Gerente:</label>
            <input type="text" 
                   [(ngModel)]="formData.staff.manager" 
                   class="edit-input" 
                   placeholder="Preenchido automaticamente"
                   [readonly]="true"
                   style="background-color: #e9ecef;">
            <small class="form-text text-muted" *ngIf="formData.staff.manager">
              Gerente do departamento selecionado
            </small>
          </div>
          <div class="detail-item">
            <label>Cargo <span style="color: red;">*</span>:</label>
            <select [(ngModel)]="formData.staff.position" 
                    class="edit-select" 
                    [disabled]="!selectedDepartmentId || isLoadingPositions"
                    required>
              <option value="">Selecione o cargo</option>
              <option *ngFor="let position of positions" [value]="position.name">
                {{ position.name }}<span *ngIf="position.level"> - {{ position.level }}</span>
              </option>
            </select>
            <small class="form-text text-muted" *ngIf="!selectedDepartmentId">
              Selecione um departamento primeiro
            </small>
            <small class="form-text text-muted" *ngIf="selectedDepartmentId && isLoadingPositions">
              Carregando cargos...
            </small>
            <small class="form-text text-muted" *ngIf="selectedDepartmentId && !isLoadingPositions && positions.length === 0">
              Nenhum cargo cadastrado neste departamento
            </small>
          </div>
          <div class="detail-item">
            <label>Data de Admissão:</label>
            <input type="date" [(ngModel)]="formData.staff.hireDate" class="edit-input">
      </div>
          <div class="detail-item">
            <label>Tipo de Contrato:</label>
            <select [(ngModel)]="formData.contract.contractType" 
                    (change)="onContractTypeChange(formData.contract.contractType)"
                    class="edit-select">
              <option value="CLT">CLT</option>
              <option value="PJ">PJ</option>
              <option value="Estagiário">Estagiário</option>
              <option value="Temporário">Temporário</option>
            </select>
        </div>

          <div class="detail-item">
            <label>Unidade:</label>
            <select [(ngModel)]="formData.staff.unit" class="edit-select">
              <option value="">Selecione a unidade</option>
              <option *ngFor="let unit of UNIT_OPTIONS" [value]="unit.value">
                {{ unit.label }}
              </option>
            </select>
          </div>

          <div class="detail-item">
            <label>Centro de Custo:</label>
            <select [(ngModel)]="formData.contract.costCenter" class="edit-select">
              <option value="">Selecione o centro de custo</option>
              <option *ngFor="let cc of costCenters" [value]="cc.code">
                {{ cc.code }} - {{ cc.name }}
              </option>
            </select>
            <small class="form-text text-muted" *ngIf="isLoadingCostCenters">
              Carregando centros de custo...
            </small>
          </div>
        
        <!-- Campos da Empresa (PJ) - Aparecem apenas quando tipo de contrato é PJ -->
        <div *ngIf="formData.contract.contractType === 'PJ'" class="company-section" style="grid-column: 1 / -1; margin-top: 20px; padding-top: 20px; border-top: 2px solid #dee2e6;">
          <h4 style="margin-bottom: 15px; color: #495057;"><i class="fas fa-building"></i> Dados da Empresa (Prestador de Serviço)</h4>
          
          <div class="detail-grid">
            <!-- CNPJ - Obrigatório -->
            <div class="detail-item">
              <label>CNPJ <span style="color: red;">*</span>:</label>
              <input type="text" 
                     [(ngModel)]="formData.contract.cnpj" 
                     (input)="applyCNPJMask($event)"
                     (change)="updateTabsCompletionStatus()"
                     class="edit-input" 
                     placeholder="00.000.000/0000-00" 
                     maxlength="18"
                     required>
            </div>
            
            <!-- Razão Social - Obrigatório -->
            <div class="detail-item full-width">
              <label>Razão Social <span style="color: red;">*</span>:</label>
              <input type="text" 
                     [(ngModel)]="formData.contract.companyName" 
                     (change)="updateTabsCompletionStatus()"
                     class="edit-input" 
                     placeholder="Nome completo da empresa" 
                     required>
            </div>
            
            <!-- Nome Fantasia - Opcional -->
            <div class="detail-item full-width">
              <label>Nome Fantasia:</label>
              <input type="text" 
                     [(ngModel)]="formData.contract.tradeName" 
                     class="edit-input" 
                     placeholder="Nome fantasia da empresa (opcional)">
            </div>
            
            <!-- Endereço da Empresa - Opcional -->
            <div class="detail-item full-width">
              <label>Endereço da Empresa:</label>
              <input type="text" 
                     [(ngModel)]="formData.contract.companyAddress" 
                     class="edit-input" 
                     placeholder="Endereço completo da empresa (opcional)">
            </div>
            
            <!-- Inscrição Estadual - Opcional -->
            <div class="detail-item">
              <label>Inscrição Estadual:</label>
              <input type="text" 
                     [(ngModel)]="formData.contract.stateRegistration" 
                     class="edit-input" 
                     placeholder="IE (opcional)">
            </div>
            
            <!-- Inscrição Municipal - Opcional -->
            <div class="detail-item">
              <label>Inscrição Municipal:</label>
              <input type="text" 
                     [(ngModel)]="formData.contract.municipalRegistration" 
                     class="edit-input" 
                     placeholder="IM (opcional)">
            </div>
            
            <!-- Email da Empresa - Opcional -->
            <div class="detail-item">
              <label>Email da Empresa:</label>
              <input type="email" 
                     [(ngModel)]="formData.contract.companyEmail" 
                     class="edit-input" 
                     placeholder="email@empresa.com.br (opcional)">
            </div>
            
            <!-- Telefone da Empresa - Opcional -->
            <div class="detail-item">
              <label>Telefone da Empresa:</label>
              <input type="text" 
                     [(ngModel)]="formData.contract.companyPhone" 
                     class="edit-input" 
                     placeholder="(00) 0000-0000 (opcional)">
            </div>
          </div>
        </div>
          <div class="detail-item">
            <label>Turno:</label>
            <select [(ngModel)]="formData.staff.shift" (change)="onWorkStartChange(getWorkStartTime())" class="edit-select">
              <option *ngFor="let shift of SHIFT_OPTIONS" [value]="shift.value">{{ shift.label }}</option>
          </select>
          </div>
          <div class="detail-item">
            <label>Horário de Trabalho:</label>
            <div class="work-schedule-editor">
              <select
                [value]="getWorkStartTime()"
                (change)="onWorkStartChange(getSelectValue($event))"
                class="edit-select">
                <option *ngFor="let startTime of WORK_START_OPTIONS" [value]="startTime.value">
                  {{ startTime.value }}
                </option>
              </select>
              <span class="work-schedule-info mx-2">até</span>
              <select
                [value]="getWorkEndTime()"
                (change)="onWorkEndChange(getSelectValue($event))"
                class="edit-select">
                <option *ngFor="let endTime of WORK_START_OPTIONS" [value]="endTime.value">
                  {{ endTime.value }}
                </option>
              </select>
              <span class="work-schedule-info ms-3">
                {{ getWorkStartTime() }} → {{ getWorkEndTime() }}
              </span>
        </div>
      </div>
        </div>
      </div>
      <!-- Botões de Navegação -->
      <div class="navigation-buttons">
        <button class="btn btn-secondary" (click)="goToPreviousTab()" [disabled]="isFirstTab()">
          <i class="fas fa-arrow-left"></i>
          Voltar
        </button>

        <button class="btn btn-primary" (click)="goToNextTab()" *ngIf="!isLastTab()" [disabled]="!isTabValid(activeTab)">
          Próximo
          <i class="fas fa-arrow-right"></i>
        </button>

        <button class="btn btn-success" (click)="saveStaff()" *ngIf="isLastTab()" [disabled]="saving || !isTabValid(activeTab)">
          <i class="fas fa-save"></i>
          {{ saving ? 'Cadastrando...' : 'Cadastrar Funcionário' }}
        </button>
      </div>
    </div>

    <!-- Aba: Salário -->
    <div *ngIf="activeTab === 'salary' && formData?.salary as salary" class="tab-panel">
      <div class="detail-section">
        <h3><i class="fas fa-money-bill-wave"></i> Dados Salariais</h3>
        <div class="detail-grid">
          <div class="detail-item">
            <label>Salário Base:</label>
            <input type="number" [(ngModel)]="salary.baseSalary" class="edit-input" placeholder="0,00 " step="0.01" min="0">
          </div>
          <div class="detail-item">
            <label>Salário Bruto:</label>
            <input type="number" [(ngModel)]="salary.grossSalary" class="edit-input" placeholder="0,00 " step="0.01" min="0">
            </div>
          <div class="detail-item">
            <label>Salário Líquido:</label>
            <input type="number" [(ngModel)]="salary.netSalary" class="edit-input" placeholder="0,00 " step="0.01" min="0">
            </div>
          <div class="detail-item">
            <label>Tipo de Salário:</label>
            <select [(ngModel)]="salary.salaryType" class="edit-select">
              <option value="Mensal">Mensal</option>
              <option value="Por Hora">Por Hora</option>
              <option value="Por Projeto">Por Projeto</option>
              <option value="Comissão">Comissão</option>
            </select>
            </div>
          <div class="detail-item">
            <label>Observações:</label>
            <textarea [(ngModel)]="salary.notes" class="edit-textarea" rows="3"></textarea>
          </div>
        </div>
      </div>
      <!-- Botões de Navegação -->
      <div class="navigation-buttons">
        <button class="btn btn-secondary" (click)="goToPreviousTab()" [disabled]="isFirstTab()">
          <i class="fas fa-arrow-left"></i>
          Voltar
        </button>

        <button class="btn btn-primary" (click)="goToNextTab()" *ngIf="!isLastTab()" [disabled]="!isTabValid(activeTab)">
          Próximo
          <i class="fas fa-arrow-right"></i>
              </button>

        <button class="btn btn-success" (click)="saveStaff()" *ngIf="isLastTab()" [disabled]="saving || !isTabValid(activeTab)">
          <i class="fas fa-save"></i>
          {{ saving ? 'Cadastrando...' : 'Cadastrar Funcionário' }}
              </button>
      </div>
    </div>

    
    <!-- Aba: Benefícios -->
    <div *ngIf="activeTab === 'benefits'" class="tab-panel">
      <div class="detail-section">
        <h3><i class="fas fa-gift"></i> Benefícios</h3>
        
        <div *ngFor="let benefit of formData.benefits; let i = index" class="benefit-item" style="margin-bottom: 20px; padding: 15px; border: 1px solid #dee2e6; border-radius: 8px;">
          <div class="benefit-header" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
            <h4 style="margin: 0;">Benefício {{ i + 1 }}</h4>
            <button *ngIf="formData.benefits && formData.benefits.length > 1" 
                    type="button"
                    class="btn btn-danger btn-sm" 
                    (click)="removeBenefit(i)">
              <i class="fas fa-trash"></i>
              Remover
            </button>
          </div>

          <div class="detail-grid">
            <div class="detail-item">
              <label>Tipo de Benefício <span style="color: red;">*</span>:</label>
              <select [(ngModel)]="benefit.benefitType" class="edit-select" required>
                <option value="">Selecione o tipo de benefício</option>
                <option *ngFor="let option of BENEFIT_TYPE_OPTIONS" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
            
            <div class="detail-item">
              <label>Valor (R$) <span style="color: red;">*</span>:</label>
              <input type="number" 
                     [(ngModel)]="benefit.amount" 
                     class="edit-input" 
                     placeholder="0,00 " 
                     step="0.01"
                     min="0"
                     required>
            </div>
            
            <div class="detail-item">
              <label>Data de Início:</label>
              <input type="date" 
                     [value]="benefit.startDate ? (benefit.startDate.split('T')[0]) : ''"
                     (change)="benefit.startDate = $any($event.target).value + 'T00:00:00.000Z'"
                     class="edit-input">
            </div>
            
            <div class="detail-item">
              <label>Status:</label>
              <div style="display: flex; align-items: center; gap: 10px;">
                <input type="checkbox" 
                       [(ngModel)]="benefit.isActive" 
                       [id]="'benefitActive' + i">
                <label [for]="'benefitActive' + i" style="margin: 0; font-weight: normal;">
                  Benefício ativo
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="add-button-container" style="margin-top: 20px;">
          <button type="button" 
                  class="btn btn-outline-primary" 
                  (click)="addBenefit()">
            <i class="fas fa-plus"></i>
            Adicionar Outro Benefício
          </button>
        </div>
      </div>
      
      <!-- Botões de Navegação -->
      <div class="navigation-buttons">
        <button class="btn btn-secondary" (click)="goToPreviousTab()" [disabled]="isFirstTab()">
          <i class="fas fa-arrow-left"></i>
          Voltar
        </button>

        <button class="btn btn-primary" (click)="goToNextTab()" *ngIf="!isLastTab()" [disabled]="!isTabValid(activeTab)">
          Próximo
          <i class="fas fa-arrow-right"></i>
        </button>

        <button class="btn btn-success" (click)="saveStaff()" *ngIf="isLastTab()" [disabled]="saving || !isTabValid(activeTab)">
          <i class="fas fa-save"></i>
          {{ saving ? 'Cadastrando...' : 'Cadastrar Funcionário' }}
        </button>
      </div>
    </div>
<!-- Aba: Documentos -->
    <div *ngIf="activeTab === 'documents'" class="tab-panel">
      <div class="detail-section">
        <h3><i class="fas fa-paperclip"></i> Documentos e Anexos</h3>
        
        <!-- Tabela de documentos -->
        <div class="table-responsive" style="margin-top: 20px;">
          <table class="documents-table">
            <thead>
              <tr>
                <th style="width: 40px;"></th>
                <th>Tipo de Documento</th>
                <th>Nome do Documento</th>
                <th>Arquivo</th>
                <th>Status</th>
                <th>Tamanho</th>
                <th style="width: 150px;">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let docType of DOCUMENT_TYPES; let i = index">
                <td class="icon-cell">
                  <i [class]="docType.icon"></i>
                </td>
                <td>{{ docType.label }}</td>
                <td>
                  <input *ngIf="!uploadedDocuments[docType.value]?.uploaded" 
                         type="text" 
                         [ngModel]="getDocumentName(docType.value)"
                         (ngModelChange)="setDocumentName(docType.value, $event)"
                         class="form-control form-control-sm"
                         placeholder="Nome do documento"
                         style="min-width: 150px;">
                  <span *ngIf="uploadedDocuments[docType.value]?.uploaded">
                    {{ getDocumentName(docType.value) }}
                  </span>
                </td>
                <td>
                  <input type="file" 
                         [id]="'file-' + docType.value"
                         [accept]="docType.value === 'photo' ? 'image/*' : '*/*'"
                         (change)="onFileSelected($event, docType.value)"
                         style="display: none;">
                  
                  <span *ngIf="!uploadedDocuments[docType.value]" style="color: #6c757d;">
                    -
                  </span>
                  <span *ngIf="uploadedDocuments[docType.value] && !uploadedDocuments[docType.value].uploaded">
                    {{ getFileName(docType.value) }}
                  </span>
                  <span *ngIf="uploadedDocuments[docType.value]?.uploaded" style="color: #28a745;">
                    {{ getFileName(docType.value) }}
                  </span>
                </td>
                <td>
                  <span *ngIf="!uploadedDocuments[docType.value]" class="status-badge status-pendente">
                    Pendente
                  </span>
                  <span *ngIf="uploadedDocuments[docType.value] && !uploadedDocuments[docType.value].uploaded && uploadStatus[docType.value] !== 'uploading'" class="status-badge status-selecionado">
                    Selecionado
                  </span>
                  <span *ngIf="uploadStatus[docType.value] === 'uploading'" class="status-badge status-enviando">
                    <i class="fas fa-spinner fa-spin"></i> Enviando...
                  </span>
                  <span *ngIf="uploadedDocuments[docType.value]?.uploaded" class="status-badge status-aprovado">
                    Enviado
                  </span>
                  <span *ngIf="uploadStatus[docType.value] === 'error'" class="status-badge status-rejeitado">
                    Erro
                  </span>
                </td>
                <td>
                  {{ getFileSize(docType.value) || '-' }}
                </td>
                <td class="actions-cell">
                  <button *ngIf="!uploadedDocuments[docType.value]" 
                          type="button"
                          class="btn btn-primary btn-sm"
                          (click)="getDocumentElement().getElementById('file-' + docType.value)?.click()"
                          title="Selecionar arquivo">
                    <i class="fas fa-upload"></i>
                  </button>
                  
                  <button *ngIf="uploadedDocuments[docType.value] && !uploadedDocuments[docType.value].uploaded" 
                          type="button"
                          class="btn btn-success btn-sm"
                          (click)="uploadDocumentToBackend(docType.value)"
                          [disabled]="uploadStatus[docType.value] === 'uploading'"
                          title="Adicionar documento">
                    <i class="fas fa-plus"></i>
                  </button>
                  
                  <button *ngIf="uploadedDocuments[docType.value] && !uploadedDocuments[docType.value].uploaded" 
                          type="button"
                          class="btn btn-warning btn-sm ml-1"
                          (click)="getDocumentElement().getElementById('file-' + docType.value)?.click()"
                          title="Alterar arquivo">
                    <i class="fas fa-edit"></i>
                  </button>
                  
                  <button *ngIf="uploadedDocuments[docType.value]" 
                          type="button"
                          class="btn btn-danger btn-sm ml-1"
                          (click)="deleteDocument(docType.value)"
                          title="Remover documento">
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          
          <!-- Seção: Outros Documentos (Múltiplos) -->
          <div class="other-documents-section mt-4">
            <h5><i class="fas fa-folder-open"></i> Outros Documentos (sem limite)</h5>
            
            <!-- Tabela de documentos "outros" -->
            <table class="documents-table" *ngIf="otherDocuments.length > 0">
              <thead>
                <tr>
                  <th style="width: 40px;"></th>
                  <th>Nome do Documento</th>
                  <th>Tamanho</th>
                  <th>Status</th>
                  <th style="width: 120px;">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let doc of otherDocuments; let i = index">
                  <td class="icon-cell">
                    <i class="fas fa-file-upload"></i>
                  </td>
                  <td>{{ doc.documentName }}</td>
                  <td>{{ formatFileSizeOther(doc.fileSize) }}</td>
                  <td>
                    <span *ngIf="doc.status === 'selecionado'" class="status-badge status-selecionado">
                      Selecionado
                    </span>
                    <span *ngIf="doc.status === 'pronto'" class="status-badge status-aprovado">
                      <i class="fas fa-check"></i> Pronto
                    </span>
                  </td>
                  <td class="actions-cell">
                    <button *ngIf="doc.status === 'selecionado'" 
                            class="btn btn-success btn-sm"
                            (click)="markOtherDocumentReady(i)"
                            title="Confirmar documento">
                      <i class="fas fa-check"></i>
                    </button>
                    <button class="btn btn-danger btn-sm ml-1" 
                            (click)="removeOtherDocument(i)"
                            title="Remover documento">
                      <i class="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            
            <!-- Botão para adicionar mais documentos -->
            <div class="add-other-document mt-3">
              <input type="file" 
                     id="other-document-input"
                     (change)="onOtherFileSelected($event)"
                     style="display: none;">
              <button type="button" 
                      class="btn btn-outline-primary"
                      (click)="getDocumentElement().getElementById('other-document-input')?.click()">
                <i class="fas fa-plus"></i> Adicionar Outro Documento
              </button>
            </div>
          </div>
        </div>
        
        <div class="documents-summary" style="margin-top: 20px; padding: 15px; background-color: #f8f9fa; border-radius: 8px;">
          <h4>Resumo dos Documentos</h4>
          <div class="summary-stats" style="display: flex; gap: 20px;">
            <div class="stat-item">
              <span class="stat-label">Total de Documentos:</span>
              <span class="stat-value">{{ formData.attachments.length }}</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">Enviados:</span>
              <span class="stat-value">{{ getUploadedDocumentsCount() }}</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">Pendentes:</span>
              <span class="stat-value">{{ getPendingDocumentsCount() }}</span>
            </div>
          </div>
        </div>

        <!-- Botões de Navegação -->
        <div class="navigation-buttons">
          <button class="btn btn-secondary" (click)="goToPreviousTab()" [disabled]="isFirstTab()">
            <i class="fas fa-arrow-left"></i>
            Voltar
          </button>

          <button class="btn btn-success" (click)="saveStaff()" [disabled]="saving || !isTabValid(activeTab)">
            <i class="fas fa-save"></i>
            {{ saving ? 'Cadastrando...' : 'Cadastrar Funcionário' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>


